import { render, staticRenderFns } from "./inform-detail.vue?vue&type=template&id=28368f18&scoped=true"
import script from "./inform-detail.vue?vue&type=script&lang=js"
export * from "./inform-detail.vue?vue&type=script&lang=js"
import style0 from "./inform-detail.vue?vue&type=style&index=0&id=28368f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28368f18",
  null
  
)

export default component.exports